module.exports = __webpack_public_path__ + "static/media/image_3.d6e19d67.png";